import React, { Component } from 'react';
import { connect } from 'react-redux';
import { injectIntl } from 'react-intl';
import { withStyles } from '@material-ui/core/styles';
import { createForm } from 'rc-form';
import moment from 'moment';
import get from 'lodash.get';
import { Grid, Typography, Button } from '@material-ui/core';

import FormInput from 'Console/components/common/form/FormInput';
import FormItemSwitch from 'Console/components/common/form/FormItemSwitch';

import { fetchAccountSettings, updateAccountGeneralSettings } from 'Console/data/accounts/actions';
import { selectAccountSettings } from 'Console/data/accounts/selectors';
import { MOMENT_DATETIME_FORMAT_DISPLAY_SECONDS } from 'Console/constants/date';

const styles = (theme) => ({
    root: {
        flexGrow: 1,
        padding: '0 24px',
        fontSize: theme.typography.pxToRem(14),
        width: '70%',
    },
    btn: {
        marginTop: theme.typography.pxToRem(20),
        marginBottom: theme.typography.pxToRem(40),
        [theme.breakpoints.down('sm')]: {
            marginTop: theme.typography.pxToRem(28),
        },
    },
    formInput: {
        width: '47%',
        [theme.breakpoints.between('xs', 'sm')]: {
            width: '100%',
            marginBottom: '5%',
        },
    },
    formName: {
        width: '20%',
        marginRight: '3%',
        [theme.breakpoints.between('xs', 'sm')]: {
            width: '100%',
            marginRight: 0,
        },
    },
});

class General extends Component {
    componentDidMount() {
        const { match, fetchAccountSettings } = this.props;

        const accountId = match.path.split('/')[3];

        fetchAccountSettings(accountId);
    }

    handleUpdateAccountGeneralSettings = () => {
        const {
            form: { getFieldsValue },
            updateAccountGeneralSettings,
            intl,
            match,
        } = this.props;

        const accountId = match.path.split('/')[3];
        const data = getFieldsValue(['firstName', 'lastName']);

        updateAccountGeneralSettings(accountId, data, {
            success: `${intl.formatMessage({ id: 'Notification.save' })}`,
            fail: `${intl.formatMessage({ id: 'Notification.fail' })}`,
        });
    };

    render() {
        const { classes, intl, form, general } = this.props;

        return (
            <Grid container className={classes.root}>
                <Grid container direction="row" alignItems="center" style={{ paddingBottom: '3%' }}>
                    <Typography variant="subtitle1" className={classes.formName}>
                        {intl.formatMessage({ id: 'Accounts.settings.general.userName' })}
                    </Typography>

                    <Typography variant="subtitle1" className={classes.formInput}>
                        {general.username}
                    </Typography>
                </Grid>

                <Grid container direction="row" alignItems="center" style={{ paddingBottom: '3%' }}>
                    <Typography variant="subtitle1" className={classes.formName}>
                        {intl.formatMessage({ id: 'Accounts.settings.general.firstName' })}
                    </Typography>

                    <Grid className={classes.formInput}>
                        <FormInput
                            fullWidth={false}
                            form={form}
                            type="text"
                            formItemKey="firstName"
                            placeholder={intl.formatMessage({
                                id: 'Accounts.settings.general.label',
                            })}
                            initialValue={get(general, 'firstName')}
                        />
                    </Grid>
                </Grid>

                <Grid container direction="row" alignItems="center" style={{ paddingBottom: '3%' }}>
                    <Typography variant="subtitle1" className={classes.formName}>
                        {intl.formatMessage({ id: 'Accounts.settings.general.lastName' })}
                    </Typography>

                    <Grid className={classes.formInput}>
                        <FormInput
                            fullWidth={false}
                            form={form}
                            type="text"
                            formItemKey="lastName"
                            placeholder={intl.formatMessage({
                                id: 'Accounts.settings.general.label',
                            })}
                            initialValue={get(general, 'lastName')}
                        />
                    </Grid>
                </Grid>

                {general.createdTimestamp && (
                    <Grid
                        container
                        direction="row"
                        alignItems="center"
                        style={{ paddingBottom: '3%', paddingTop: '2%' }}
                    >
                        <Typography variant="subtitle1" className={classes.formName}>
                            {intl.formatMessage({ id: 'Accounts.settings.general.createdAt' })}
                        </Typography>

                        <Typography variant="subtitle1" className={classes.formInput}>
                            {moment(general.createdTimestamp, 'x').format(
                                MOMENT_DATETIME_FORMAT_DISPLAY_SECONDS
                            )}
                        </Typography>
                    </Grid>
                )}

                {/* @TODO to use when will be BE ready */}
                {/* <Grid container direction="row" alignItems="center">
                    <Typography variant="subtitle1" className={classes.formName}>
                        {intl.formatMessage({ id: 'Buttons.switchAdministrator' })}
                    </Typography>

                    <FormItemSwitch initialValue form={form} formItemKey="atministrator-active" />
                </Grid> */}

                <Grid container alignItems="center">
                    <Typography variant="button">
                        <Button
                            id="yeself-button"
                            variant="contained"
                            color="primary"
                            onClick={this.handleUpdateAccountGeneralSettings}
                            className={classes.btn}
                        >
                            {intl.formatMessage({ id: 'Buttons.save' })}
                        </Button>
                    </Typography>
                </Grid>
            </Grid>
        );
    }
}

export default withStyles(styles)(
    injectIntl(
        connect(
            (state) => ({
                general: selectAccountSettings(state),
            }),
            {
                fetchAccountSettings,
                updateAccountGeneralSettings,
            }
        )(createForm()(General))
    )
);
